<template>
  <div class="container">
    <div v-if="dataReady" class="questionnaireList">
      <div class="questionnaireHeader">
        <img src="../../assets/images/question4.jpg" alt="">
        <div class="title">{{question.title}}</div>
        <div class="summary" v-html="question.summary" ref="summary"></div>
      </div>
      <div class="questionnaireBody">
        <div class="question-list" v-for="(item, index) in question.questionList" :key="item.questionid">
          <div class="question-title">Q{{index + 1}}：{{item.questionname}}</div>
<!--           <van-radio-group v-model="answer[item.id]">
            <van-radio v-for="option in item.optionlist" :key="option.id" :name="option.id">
              <template #default="props">
                <div class="radio_label">
                  <div class="logo" v-if="option.logo" :style="{backgroundImage: 'url(' + option.logo + ')'}"></div>
                  <div class="content" v-html="option.content"></div>
                </div>
              </template>
            </van-radio>
          </van-radio-group> -->
          <van-radio-group v-model="answer[item.id]">
            <van-cell-group>
              <van-cell v-for="option in item.optionlist" :key="option.id" clickable @click="choose(item.id, option.id)">
                <template #title>
                  <div class="radio_content">
                    <!-- <img v-if="option.logo" class="logo" :src="option.logo" alt=""> -->
                    <div v-if="option.logo" class="logo" :style="{backgroundImage: 'url(' + option.logo + ')'}"></div>
                    <div class="label">
                      <div class="label_val" v-html="option.content"></div>
                      <span class="more" @click.stop="seemore(option.content)">「查看详情」</span>
                    </div>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="option.id" />
                </template>
              </van-cell>
<!--             <van-radio v-for="option in item.optionlist" :key="option.id" :name="option.id">
              <template #default="props">
                <div class="radio_label">
                  <div class="logo" v-if="option.logo" :style="{backgroundImage: 'url(' + option.logo + ')'}"></div>
                  <div class="content" v-html="option.content"></div>
                </div>
              </template>
            </van-radio> -->
            </van-cell-group>
          </van-radio-group>
        </div>
<!--         <div class="progress" v-if="question.isresult">
          <div v-for="(bean, index) in wjStatisticsBeanList" :key="index" :class="bean.memberselect === 1 ? 'progress-list mySelect' : 'progress-list'">
            <span class="progress-title">{{bean.memberselect === 1 ? bean.content + '（已选择）' : bean.content}}</span>
            <van-progress :percentage="bean.percentage ? parseInt(bean.percentage) : 0" stroke-width="40"/>
            <span class="progress-percent">{{bean.num}}票</span>
          </div>
          <p>{{question.wjStatisticsNum}}人参与  投票进行中</p>
        </div> -->
      </div>
      <div class="questionnaireFooter" v-if="question.questionList && question.questionList.length > 0">
        <van-button v-if="question.mode === '投票'" class="btn rankinglistBtn" @click="goRanking">查看排行榜</van-button>
        <van-button :class="question.isresult ? 'btn isresult' : 'btn'" color="#DB2D2D" :disabled="question.isresult" @click="submit">{{btnText}}</van-button>
      </div>
      <van-popup v-model="show" class="questionnaire_popup">
        <div class="questionnaire_popup_header">
          <van-icon name="cross" @click="closePopup" />
        </div>
        <div class="questionnaire_popup_body" v-html="nowShow"></div>
      </van-popup>
    </div>
    <div class="loading" v-if="!dataReady">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  import $ from 'jquery'
  export default {
    namt: 'questionnaireList',
    data () {
      return {
        dataReady: false,
        show: false,
        nowShow: '',
        question: {},
        answer: {},
        btnText: "确认提交"
      }
    },
    created () {
      this.$toast.allowMultiple()
      this.$fetch.get(API.QUESTIONNAIREQUESTIONLIST, {
        questionnaireid: this.$route.query.id
      }).then(res => {
        // console.log(res)
        this.question = res.data
        if (res.data.isresult) {
          this.btnText = '投票'
        } else if (res.data.mode === '投票') {
          this.btnText = '投票'
        } else {
          this.btnText = '确认提交'
        }
        for (var i = 0; i < res.data.questionList.length; i++) {
          // this.answer[] = ''
          this.$set(this.answer,res.data.questionList[i].id,'')
        }
        // console.log(this.answer)
        this.dataReady = true
        this.$nextTick(function () {
          $(".label").each(function(index, el) {
            if ($(el).height() > 120) {
              $(el).height(120)
              $(el).find('.more').show()
            }
          })
          if (u.indexOf('MicroMessenger') > -1) {
            var summary = this.$refs.summary ? this.$refs.summary.innerText.trim().replace(/\ +/g,"").replace(/[\r\n]/g,"").replace(/\s/g,"").substr(0, 50) : '广东科技报'
            this.$fetch.get(API.GETWECHATINVOKESIGN, {
              url: window.location.href
            }).then(response => {
              let data = response.data
              wx.config({
                debug: false,
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              })
              wx.ready(function(){
                wx.updateAppMessageShareData({
                  title: res.data.title,
                  desc: summary,
                  link: window.location.href,
                  imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
                  success: function() {
                    console.log('分享成功')
                  }
                })
                wx.updateTimelineShareData({
                  title: res.data.title,
                  link: window.location.href,
                  imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
                  success: function() {
                    console.log('分享成功')
                  }
                })
                wx.onMenuShareWeibo({
                  title: res.data.title,
                  desc: summary,
                  link: window.location.href,
                  imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
                  success: function() {
                    console.log('分享成功')
                  },
                  cancel: function(){
                    console.log('分享取消')
                  }
                })
              })
            })
          }
        })
      }).catch(error => {
        console.log(error)
      })
    },
    methods: {
      submit () {
        var cansubmit = true
        var _this = this
        var answerArr = []
        Object.keys(_this.answer).forEach(function (index) {
          if (_this.answer[index].length < 1) {
            cansubmit = false
          } else {
            var obj = {
              'wjquestionid': index,
              'optionid': _this.answer[index]
            }
            answerArr.push(obj)
          }
        })
        if (!cansubmit) {
          var cantmsg = this.question.mode === '投票' ? '请选择你的选项' : '请先完成所有答题再提交'
          this.$toast.fail(cantmsg)
          return
        }
        if (this.$store.state.token) {
          const load = this.$toast({
            type: 'loading',
            duration: 0,
            loadingType: 'spinner',
            forbidClick: true
          })
          // console.log(answerArr)
          this.$fetch.post(API.SAVEWJRESULT, {
            questionnaireid: this.$route.query.id,
            questionnairejson: JSON.stringify(answerArr)
          }).then(response => {
            // console.log(response)
            load.clear()
            if (response.status === 405) {
              this.$toast({
                message: response.message,
                duration: 3000
              })
              return
            }
            if (response.status !== 200) {
              this.$toast.fail(response.message)
              return
            }
            this.$toast.success({
              message: this.question.mode === '投票' ? '投票成功！' : '提交成功!',
              forbidClick: true
            })
            if (this.question.mode === '投票') {
              setTimeout(function(){
                _this.$router.replace({
                  path: '/questionnaire/ranking',
                  query: {
                    id: _this.$route.query.id
                  }
                })
              }, 2000)
            } else {
              setTimeout(function(){
                _this.$router.replace({
                  path: '/result',
                  query: {
                    type: 'questionnaire'
                  }
                })
              }, 2000)
            }
          }).catch(error => {
            load.clear()
            console.log(error)
          })
        } else {
          let questdata = {
            questionnaireid: this.$route.query.id,
            questionnairejson: JSON.stringify(answerArr)
          }
          this.$store.commit('savequest', questdata)
          if (u.indexOf('MicroMessenger') > -1) {
            var hrefF = process.env.VUE_APP_CURRENTMODE === 'test' ? '/h5/#' : '/#'
            var URL = this.question.mode === '投票' ? hrefF + '/questionnaire/ranking?auto=submitquest' : hrefF + '/result?type=questionnaire&auto=submitquest'
            this.$fetch.post(API.GETWECHATAUTHURI, {
              url: window.location.origin + URL
            })
              .then(response => {
                // console.log(response)
                if (response.status === 200) {
                  window.location.href = response.data.uri
                } else {
                  // console.log(response.message)
                }
              })
          } else {
            this.$dialog.alert({
              message: '请先前往登录再提交问卷'
            }).then(() => {
              this.$router.push({
                path: '/login',
                query: {
                  type: 'questionnaire',
                  mode: this.question.mode
                }
              })
            })
          }
        }
      },
      seemore (val) {
        this.nowShow = val
        this.show = true
        return false
      },
      closePopup () {
        this.show = false
      },
      choose (item, option) {
        this.$set(this.answer, item, option)
      },
      goRanking () {
        this.$router.replace({
          path: '/questionnaire/ranking',
          query: {
            id: this.$route.query.id
          }
        })
      }
    }
  }
</script>

<style lang="stylus">
  
</style>